import { render, staticRenderFns } from "./DrivetrainSelector.vue?vue&type=template&id=ca319a4a"
import script from "./DrivetrainSelector.vue?vue&type=script&lang=js"
export * from "./DrivetrainSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports